import type { OrderToHealthKitProps } from './OrderToHealthKit.types';

// NOTE: `OrderToHealthKit` is iOS only component, since it's communicating with Health Kit API
export const OrderToHealthKit = (_: OrderToHealthKitProps) => null;
